const contactBankEn = {
  'contactBank': 'Contact with the bank',
};

export default contactBankEn;
